import { Logs } from '@/api';
import Crypto from 'crypto-js';
import store from '@/store';

const MODES = {
  none: 0,
  warning: 1,
  info: 2,
  error: 3,
};
const _time = 333;
const _queue = [];
let _mode;

function setMode() {
  _mode = MODES[window.ENV.debug || 'none'];
}

function send(msg, mode) {
  const { email } = store.state.User;
  const date = (new Date()).toISOString();
  const format = [`[${date}]`, `[${Crypto.MD5(email)}]`].concat(msg);
  let formatSend = '';

  switch (mode) {
    case MODES.warning: {
      console.warn.apply(null, format);
      break;
    }
    case MODES.info: {
      console.debug.apply(null, format);
      break;
    }
    case MODES.error: {
      console.error.apply(null, format);
      break;
    }
    default: {
      console.log.apply(null, format);
    }
  }

  formatSend = format.map((m) => {
    if (typeof m === 'object') return JSON.stringify(m, null, 2);
    return m.toString();
  }).join(' ');

  _queue.push(() => {
    Logs.send({ message: formatSend, type: mode });
  });
}

function warn(...msg) {
  if (MODES.warn <= _mode) {
    send(msg, MODES.warning);
  }
}

function info(...msg) {
  if (MODES.info <= _mode) {
    send(msg, MODES.info);
  }
}

function error(...msg) {
  if (MODES.error <= _mode) {
    send(msg, MODES.error);
  }
}

// [Notes]
// Not the best solution, this only ensures a call every 333 milliseconds, but the optimal code
// should do a call every 333 milliseconds if there's not another call ongoing, to avoid a
// 429 limit request exceeded.
function executeQueue() {
  setInterval(() => {
    try {
      const f = _queue.shift();
      if (f) f();
    } catch (e) {
      console.error(e);
    }
  }, _time);
}

export default {
  warn,
  info,
  error,
  executeQueue,
  setMode,
};
